import { candidateDetailActions } from '@AMIEWEB/Candidate/CandidateProfile/Profile/CandidateDetails.redux';
import { ExperienceEditType } from 'app/models/Candidate/CandidateProfile';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styledComponent from 'styled-components';
import { colors } from 'styles/styleVariables';
import { formatFormData } from 'app/components/Candidate/CandidateProfile/WorkExperience/Edit/Helpers/FormDataHelper';
import { disciplineDataSelector, specialtiesSelector, brandsSelector } from 'store/redux-store/lookup/lookup.selectors';

const GridCellEditWorkExperience = props => {
  const { params } = props;
  const dispatch = useDispatch();
  const disciplines = useSelector(disciplineDataSelector);
  const specialtiesLookup = useSelector(specialtiesSelector);
  const travelCompanies = useSelector(brandsSelector);

  const handleClick = () => {
    params.value === 'Personal Time Off'
      ? dispatch(
          candidateDetailActions.setEditExperience({
            isModalOpen: true,
            timeOff: params.row,
            type: ExperienceEditType.TimeOff,
            workExperience: undefined,
            rowData: params.row,
          }),
        )
      : dispatch(
          candidateDetailActions.setEditExperience({
            isModalOpen: true,
            workExperience: formatFormData(params.row, disciplines, specialtiesLookup, travelCompanies),
            type: ExperienceEditType.WorkExperience,
            timeOff: undefined,
            rowData: params.row,
          }),
        );
  };

  return <ClickableLink onClick={handleClick}>{params.value}</ClickableLink>;
};

const ClickableLink = styledComponent.div`
  color: ${colors.amnBlue};
  cursor: pointer;
  font-size: 12px;
  font-weight: initial;
`;

export default GridCellEditWorkExperience;
